const INITIAL_STATE: any = {
  message: '',
  open: false,
  severity: 'error',
  duration: 6000,
};

const apiAlert = (state = INITIAL_STATE, action: any): any => {
  switch (action.type) {
    case 'MESSAGE': {
      return { ...state, message: action.payload.message };
    }
    case 'OPEN': {
      return { ...state, open: action.payload.open };
    }
    case 'SERVEITY': {
      return { ...state, severity: action.payload.severity };
    }
    case 'DURATION': {
      return { ...state, duration: action.payload.duration };
    }
    default:
      return state;
  }
};

export default apiAlert;
